import {getFormattedZipCode} from '../../../../common/util/Natutil'
import {Nullable} from '../../../../../app/TypeHelpers'
import moment from 'moment'
import {convertToNullableMoment} from '../../../../../components/reservations/helpers/helpers'


export const getFormattedAddress = (
    zipcode: string,
    prefecture: string,
    address2: string,
    address3: string,
    buildingRoomNumber: string
): string => {
    const address = []
    if (zipcode) {
        address.push(getFormattedZipCode(zipcode))
    }
    address.push(`${prefecture}${address2}${address3}${buildingRoomNumber}`)

    return address.join('　')
}

export const getFormattedDate = (
    date: string
): string => {
    const dateMoment: Nullable<moment.Moment> = convertToNullableMoment(date, null)
    return (dateMoment) ? dateMoment.format('YYYY年M月D日') : ''
}